import Text from "../Text";
import cn from "classnames";
import Slider from "react-slick";
import { useRef } from "react";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import analytics from "../../../utils/analytics";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const EventCarousel = ({
  data = [],
  className,
  titleClassName = "event-carousel__title",
  ...props
}) => {
  const sliderRef = useRef();
  const classNames = cn("event-carousel", className);

  const settings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 15000,
    infinite: false,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const { setOpenPopUp: toglePopUp } = usePageContextFunction();
  const { city } = usePageContextState();

  return (
    <div className="carousel-wrapper">
      <Slider ref={sliderRef} {...settings}>
        {data.map((value, idx) => (
          <div
            key={idx}
            className={classNames}
            onClick={() => {
              const payload = {
                event: `KeseruanHariIni_${city ?? analytics.defaultCity}`,
                article_name: value?.title,
                article_id: value?.id,
              };
              analytics.sendEvent(payload);
              toglePopUp({ state: true, data: value });
            }}
          >
            <div>
              <img
                className="event-carousel__image"
                src={imgPath + value?.key_visual}
                alt={value?.title}
              />
              <div className={"event-carousel__content-text"}>
                <Text size="medium" weight="bold" className={titleClassName}>
                  {value?.title}
                </Text>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
export default EventCarousel;
